"use strict";

exports.__esModule = true;
exports.FormControlHelperText = void 0;

var React = _interopRequireWildcard(require("react"));

var _FormControl = require("./FormControl.styles");

var _context = require("./context");

var _hooks = require("@manifest-ui/hooks");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/form-control/src/FormControlHelperText.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const FormControlHelperText = React.forwardRef((props, ref) => {
  const {
    id: idProp,
    ...other
  } = props;
  const {
    helperTextId,
    isInvalid,
    setHasHelperText
  } = (0, _context.useFormControl)();
  const mergedRef = (0, _hooks.useMergedRef)(ref, node => {
    if (!node) return;
    setHasHelperText?.(true);
  });
  return React.createElement(_FormControl.StyledFormControlHelperText, _extends({
    "data-invalid": isInvalid ? '' : null,
    id: idProp ?? helperTextId,
    ref: mergedRef
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }));
});
exports.FormControlHelperText = FormControlHelperText;
FormControlHelperText.displayName = 'FormControlHelperText';